/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-30 13:58:15
 */
import { useEffect, useState } from "react";
import { getBrowserLang } from "@/utils/util";
import { ConfigProvider } from "antd";
import { connect } from "react-redux";
import { setCurrentUser, setLanguage, setToken } from "@/redux/modules/global/action";
import { BrowserRouter } from "react-router-dom";
import AuthRouter from "@/routers/utils/authRouter";
import Router from "@/routers/index";
import useTheme from "@/hooks/useTheme";
import enUS from "antd/lib/locale/en_US";
import zhCN from "antd/lib/locale/zh_CN";
import i18n from "i18next";
import { I18nextProvider } from "react-i18next";

import { getCurrentUser } from "@/api/modules/user";

import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import localeData from "dayjs/plugin/localeData";
import ReactGA from "react-ga4";

dayjs.extend(utc);

dayjs.extend(timezone);
dayjs.extend(weekday);

dayjs.extend(localeData);

ReactGA.initialize("G-W3NLXS7488");

const App = (props: any) => {
	const { assemblySize, setCurrentUser, themeConfig } = props;
	const { language, setLanguage } = props;
	const [i18nLocale, setI18nLocale] = useState(enUS);

	// 全局使用主题
	useTheme(themeConfig);

	// 设置 antd 语言国际化
	const setAntdLanguage = () => {
		switch (language) {
			case "en_US":
				setI18nLocale(enUS);
				break;
			case "zh_CN":
				setI18nLocale(zhCN);
				break;
			default:
				setI18nLocale(enUS);
				break;
		}
	};

	useEffect(() => {
		if (!language) {
			setLanguage(getBrowserLang());
		}
		i18n.changeLanguage(language.split("_")[0]);
		setAntdLanguage();
	}, [language]);

	useEffect(() => {
		// TODO 临时解决方案，应该放在路由守卫中
		const loginWhiteList = ["/login", "/register", "/FindPassword"];
		if (loginWhiteList.includes(window.location.pathname)) {
			return;
		}

		const doLogOut = () => {
			setToken("");
			localStorage.removeItem("nickname");
			window.location.href = "/login";
		};

		try {
			getCurrentUser().then(res => {
				if (res.code === 200) {
					setCurrentUser(res.data);
					setAntdLanguage(res.data.locale);
					localStorage.setItem("nickname", res.data.nickname);
				} else if (res.code === 401) {
					doLogOut();
				} else {
					doLogOut();
				}
			});
		} catch (e) {
			doLogOut();
		}
	}, []);

	return (
		<I18nextProvider i18n={i18n}>
			<BrowserRouter>
				<ConfigProvider
					locale={i18nLocale}
					componentSize={assemblySize}
					theme={{
						token: {
							colorPrimary: "#565BDD",
							colorLink: "#565BDD"
						},
						components: {
							Menu: {
								itemBorderRadius: 4,
								fontSize: 14,
								itemColor: "#707793",
								itemHeight: 40,
								itemMarginBlock: 4,
								itemMarginInline: 0,
								itemPaddingInline: 0
							}
						}
					}}
				>
					<AuthRouter>
						<Router />
					</AuthRouter>
				</ConfigProvider>
			</BrowserRouter>
		</I18nextProvider>
	);
};

const mapStateToProps = (state: any) => state.global;
const mapDispatchToProps = { setLanguage, setCurrentUser };
export default connect(mapStateToProps, mapDispatchToProps)(App);
